const emitUpdateMsg = (itemId) => {
  // send post message to parent window
  window.postMessage({
      type: 'cart-update',
      payload: {
          status: 'item-removed',
          itemId,
      },
  }, '*');
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {

    
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));

    
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const itemselect = document.getElementById(`CartItem-${line}`);
    if(!itemselect){
      this.disableLoading();
    }
    const itemId = document.getElementById(`CartItem-${line}`).dataset.productId;
     // this is to disable the button until the response from the previous one comes up

     document.querySelectorAll(`#CartItem-${line} .quantity__button`).forEach(function(element){
      element.style.pointerEvents ="none";
    });
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    if (parseInt(quantity, 10) === 0) {
      // if a cart item is removed / qty 0, emit a message to the parent window so we can refresh recommended items
      
      emitUpdateMsg(itemId); // send postmessage to parent window
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        try {  
          
          // document.getElementById(`CartItem-${line}`).style.pointerEvents ="auto";
      
          }  catch(e) {
            console.log(e);
          }
      

        return response.text();
      })
      .then((state) => {
        
        
        const parsedState = JSON.parse(state);
   const getitemcount = parsedState.item_count;
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        // updateFreeShipping(parsedState.items_subtotal_price);
if (typeof getitemcount !== 'undefined') {
        if (window.Spiral.updateUtilityFreeShipping) {
          window.Spiral.updateUtilityFreeShipping(parsedState.items_subtotal_price);
        }

        if (window.Spiral.updateCartFreeShipping) {
          window.Spiral.updateCartFreeShipping(parsedState.items_subtotal_price);
        }
         if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    
        this.getSectionsToRender().forEach((section => {
         
        
             
          if(document.getElementById(section.id) || document.getElementById(section.id)){
          let elementToReplace =   document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
           if(elementToReplace) {
           elementToReplace.innerHTML =  this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
             }
            }
          
        }));
}
        if (typeof getitemcount == 'undefined') {
          this.updateLiveRegions_singleitemInCart(line, parsedState.item_count);
        }
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
        document.querySelectorAll(`#CartItem-${line} .quantity__button`).forEach(function(element){
          element.style.pointerEvents ="auto";
        });
        
      }).catch(() => { 
      
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
        document.querySelectorAll(`#CartItem-${line} .quantity__button`).forEach(function(element){
          element.style.pointerEvents ="auto"
        });

      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

    updateLiveRegions_singleitemInCart(line, itemCount) {
  
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const quantityminusone = quantityElement.value - 1;
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityminusone
        );
       const current_itemId = document.getElementById(`CartItem-${line}`).dataset.productId;
          var $cartItem = $('.cart-item[data-product-id="' + current_itemId + '"]');
          $cartItem.find('.quantity__input').val(quantityminusone).trigger('change');


    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
      disableLoading();
  }
  
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};


$(".quantity__button").click(function(){
  $(this).css("pointer-events","none");
})